import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { unwrapResult } from '@/shared/utils/unwrapResult'
import { resultQueryFn, resultMutationFn } from '@/shared/utils/queryHelpers'
import { queryKeys } from '@/shared/utils/queryKeys'
import { fetchResources, searchResources, syncAll, syncType } from './api'
import type { ResourceType } from './types'

export function useResources(resourceType?: ResourceType) {
  return useQuery({
    queryKey: queryKeys.resources.list(resourceType),
    queryFn: resultQueryFn(() => fetchResources(resourceType)),
  })
}

export function useResourceSearch(query: string, resourceType?: ResourceType) {
  return useQuery({
    queryKey: queryKeys.resources.search(query, resourceType),
    queryFn: resultQueryFn(() => searchResources(query, resourceType)),
    enabled: query.length > 0,
  })
}

export function useSyncResources() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async () => unwrapResult(await syncAll()),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.resources.all })
    },
  })
}

export function useSyncResourceType() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: resultMutationFn(syncType),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.resources.all })
    },
  })
}
